import { isPossiblePhoneNumber, isValidNumber, parsePhoneNumber } from 'libphonenumber-js';

export const isValidPhoneNumber = (phoneNumber: string): boolean => {
  if (!phoneNumber) {
    return false;
  }
  // First try to validate with country code if present, otherwise default to South Africa
  try {
    if (phoneNumber.trim().startsWith('+')) {
      // Has country code, validate without default country
      return isValidNumber(phoneNumber);
    }
    // No country code, assume South Africa
    return isValidNumber(phoneNumber, 'ZA');
  } catch {
    return false;
  }
};

export const parseMobile = (mobile: string) => {
  if (!mobile) {
    return mobile;
  }
  if (isValidPhoneNumber(mobile)) {
    try {
      const parsedMobile = parsePhoneNumber(mobile, 'ZA');
      return parsedMobile.formatInternational();
    } catch {
      return mobile;
    }
  }
  return mobile;
};

export const isPossibleMobile = (value: string) => {
  return isPossiblePhoneNumber(value, 'ZA');
};

export const parseUrl = (url: string) => {
  if (!url || url.trim() === '') return true;
  // Allow URLs with or without protocol
  const urlPattern = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/i;
  return urlPattern.test(url);
};
